var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMy = function SvgMy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 30,
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 14"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12.857,
    y: 0.571,
    fill: "#fff",
    rx: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "MY_svg__a",
    width: 18,
    height: 14,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 12.857,
    y: 0.571,
    fill: "#fff",
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#MY_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E1244A",
    fillRule: "evenodd",
    d: "M18 .571H8.571v.858H18zm0 1.715H8.571v.857H18zM8.571 4H18v.857H8.571zM18 5.714H8.571v.857H18zM0 7.43h18v.857H0zm18 1.714H0V10h18zM0 10.857h18v.857H0zm18 1.714H0v.858h18z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C3F8E",
    d: "M0 .571h10.286v6.857H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD34F",
    fillRule: "evenodd",
    d: "M5.143 1.857c.263 0 .516.048.749.135a2.571 2.571 0 1 0 0 4.017 2.143 2.143 0 1 1-.749-4.151m.97 3.688.744-.842.744.842-.194-1.107 1.122-.057-.987-.537.655-.913-1.035.436-.305-1.081-.305 1.08-1.035-.435.655.913-.986.537 1.122.057z",
    clipRule: "evenodd"
  }))));
};
export default SvgMy;